/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { ArrowLeftLine } from '@entrata/portals-common/lib/icons';
import { DARK_BLUE } from 'constants/theme';

import styled from '@emotion/styled';

const StyledDiv = styled('div')`
  width: 100%;
`;

const StyledLink = styled.a`
  height: 48px;
  color: ${({ theme }) => theme.secondary.dark};
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  padding: 0 16px;
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;
  svg {
    padding-right: 8px;
    color: ${DARK_BLUE};
  }
`;

const BackLink = ({ children, to }) => (
  <StyledDiv>
    <StyledLink onClick={() => navigate(to)}>
      <ArrowLeftLine size={12} />
      {typeof children == 'string' ? children.toUpperCase() : children}
    </StyledLink>
  </StyledDiv>
);

BackLink.propTypes = {
  children: PropTypes.any,
  to: PropTypes.string.isRequired,
};

export default BackLink;
